import {Grid, useReachGoalCallback} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import clsx from 'clsx'
import React, {memo} from 'react'

import {classes} from './styles'
import {PromoBaseProps} from './types'

const PromoBase: React.FC<PromoBaseProps> = props => {
  const t = useI18n()
  const reachGoalCallback = useReachGoalCallback()

  const onBannerClick = () => {
    reachGoalCallback('OLD_INSTALL_BANNER_CLICK')
  }

  const {
    title = t('route_install_yandex_go'),
    text = t('route_promo_text'),
    link = 'https://8jxm.adj.st/?adjust_t=yyhnvg_t4c0o0&adj_deeplink=yandextaxi%3A%2F%2F&adjust_campaign=%5BYT%5DMA_UA-goal_RU-ALL-ALL_yt-site-footer-button',
    fullWidth = false,
  } = props

  return (
    <a className={clsx(classes.container, !fullWidth && classes.containerYandex)} href={link} onClick={onBannerClick}>
      <Grid justify="space-around" container>
        <Grid className={fullWidth && classes.adaptiveGrid} xs={9} item>
          <div className={classes.title}>{title}</div>
          <div className={classes.text}>{text}</div>
        </Grid>
        <Grid item>
          <div className={clsx(classes.icon, classes.iconYandex, fullWidth && classes.fullWidthIcon)} />
        </Grid>
      </Grid>
    </a>
  )
}

export default memo(PromoBase)
